interface AccentCandidates {
  [key: string]: string;
}

/**
 * Mapping of base characters to their accent variants
 * Supports both lowercase and uppercase characters
 */
export const ACCENT_CANDIDATES: AccentCandidates = {
  // Lowercase accents
  w: 'ŵ',
  e: 'è é ê ë ě ẽ ē ė ę',
  r: 'ř',
  t: 'ț ť þ',
  y: 'ý ŷ ÿ',
  u: 'ù ú û ü ǔ ũ ū ű ů ų',
  i: 'ì í î ï ǐ ĩ ī ı į',
  o: 'ò ó ô ö ǒ œ ø õ ō',
  a: 'à á â ä ǎ æ ã å ā ą',
  s: 'ß ş ș ś š',
  d: 'ď ð',
  g: 'ğ ġ',
  h: 'ħ',
  k: 'ķ',
  l: 'ł ļ ľ',
  z: 'ź ž ż',
  c: 'ç ć č ċ',
  n: 'ñ ń ņ ň',

  // Uppercase accents
  W: 'Ŵ',
  E: 'È É Ê Ë Ě Ẽ Ē Ė Ę',
  R: 'Ř',
  T: 'Ț Ť Þ',
  Y: 'Ý Ŷ Ÿ',
  U: 'Ù Ú Û Ü Ǔ Ũ Ū Ű Ů Ų',
  I: 'Ì Í Î Ï Ǐ Ĩ Ī I Į',
  O: 'Ò Ó Ô Ö Ǒ Œ Ø Õ Ō',
  A: 'À Á Â Ä Ǎ Æ Ã Å Ā Ą',
  S: 'ß Ş Ș Ś Š',
  D: 'Ď Ð',
  G: 'Ğ Ġ',
  H: 'Ħ',
  K: 'Ķ',
  L: 'Ł Ļ Ľ',
  Z: 'Ź Ž Ż',
  C: 'Ç Ć Č Ċ',
  N: 'Ñ Ń Ņ Ň',
};
